import { DateTime } from 'luxon';

export function parseDate(timestamp, timezone) {
    return DateTime.fromFormat(`${timestamp} ${timezone}`, "yyyyLLdd'T'HHmmss z");
}

export function differentDays(datetime1, datetime2) {
    return datetime1.day != datetime2.day;
}